<template>
  <div class="layview">
    <div class="header" style="width: 100%;">
      <div class="header-wrap radius">
        <h1 class="top-title"><i class="fa fa-table" aria-hidden="true"></i>周报</h1>
      </div>
    </div>
    <div class="viewmain">
      <avue-form ref="form" :option="option" v-model="form" :disabled=true>
        <template slot-scope="{row}" slot="menuButton">
          <el-button type="text" @click="getcopszrw">获取上周周报</el-button>
          <el-button type="text" @click="getbzrw">获取本周日报</el-button>
        </template>
        <template slot-scope="{row}" slot="RWMC">
          <el-tooltip :content="row.RWMC" placement="top">
            <el-input :value="row.RWMC" size="small" placeholder="请选择二级任务" disabled></el-input>
          </el-tooltip>
        </template>
        <template slot-scope="{row}" slot="ZRW_TK">
          <selectDialogeData :datas="row.ZRW_TK" @onChecked="handleCheckedSelect($event, row)"></selectDialogeData>
        </template>
        <template slot-scope="{size}" slot="menuForm">
          <el-button type="success" :size="size" @click="seavForm(form)">保存</el-button>
          <el-button type="primary" :size="size" @click="handleSubmit(form)">提交</el-button>
        </template>
      </avue-form>
    </div>
  </div>
</template>
<script>
import crudPageMinix from '@/businessManagement/utils/crudPageMinix.js'
import selectDialogeData from '@/portal/other/dataPortal/components/selectData.vue'
export default {
  mixins: [crudPageMinix],
  components: { selectDialogeData },
  data() {
    return {
      sjrw: '',
      isshowqzbl: false,
      sjh: '',
      txrq: '',
      ProcessKey: {},
      userInfo: {},
      componentName: 'SelectJFXMDataDialog',
      form: {},
      option: {
        labelWidth: 150,
        emptyBtn: false,
        submitBtn: false,
        group: [
          {
            label: '基础信息',
            arrow: false,
            prop: 'jcxx',
            column: [
              {
                label: '姓名',
                prop: 'XM',
                span: 8,
                disabled: true
              },
              {
                label: '部门',
                prop: 'orgId',
                type: 'select',
                dicData: [],
                props: {
                  label: 'name',
                  value: 'id'
                },
                span: 8
              },
              {
                label: '联系电话',
                prop: 'LXDH',
                span: 8,
                disabled: true
              },
              {
                label: '汇报周',
                prop: 'TXRQ',
                span: 8,
                type: 'week',
                format: 'yyyy 第 WW 周',
                valueFormat: 'yyyy-MM-dd',
                change: ({ value }) => {
                  //   this.loadData(this.userInfo.loginName, value)
                  //   console.log(value)
                  this.txrq = value
                }
              },
              {
                label: '流程编号',
                prop: 'processCode',
                span: 8,
                disabled: true
              }
            ]
          },
          {
            label: '任务信息',
            arrow: false,
            prop: 'rwxx',
            labelPosition: 'top',
            column: [
              {
                label: '',
                prop: 'menuButton',
                formslot: true
              },
              {
                label: '本周任务',
                prop: 'BZRW',
                type: 'dynamic',
                span: 24,
                children: {
                  align: 'left',
                  headerAlign: 'center',
                  rowAdd: (done) => {
                    // this.$message.success('新增回调')
                    done({
                      RWLX: [],
                      ZRW: '',
                      ZRW_TK: [],
                      // SJRWSX: this.sjrw,
                      SRW: ''
                      // WCZT: '',
                      // SFYXZRWJD: '',
                      // SFYXXTGZTX: '',
                      // ZGS: '',
                      // gs: '',
                      // KHZG: this.mykhzg
                    })
                  },
                  rowDel: (row, done) => {
                    // this.$message.success('删除回调' + JSON.stringify(row))
                    done()
                    // console.log(row)
                  },
                  column: [
                    {
                      label: '任务类型',
                      prop: 'RWLX',
                      type: 'select',
                      filterable: true,
                      minWidth: 160,
                      dicData: [],
                      props: {
                        label: 'lbmc',
                        value: 'id'
                      }
                    },
                    {
                      label: '一级任务',
                      prop: 'RWMC',
                      hide: false,
                      minWidth: 160,
                      width: 160,
                      disabled: true,
                      formslot: true
                    },
                    {
                      label: '二级任务',
                      prop: 'ZRW_TK',
                      formslot: true,
                      hide: false,
                      width: 200,
                      minWidth: 200
                    },
                    // {
                    //   label: '三级任务属性',
                    //   prop: 'SJRWSX',
                    //   minWidth: 180,
                    //   dicData: [],
                    //   type: 'select',
                    //   props: {
                    //     label: 'itemValue',
                    //     value: 'itemCode'
                    //   }
                    // },
                    {
                      label: '四级任务',
                      prop: 'SRW',
                      minWidth: 320
                    },
                    {
                      label: '完成情况',
                      prop: 'WCZT',
                      type: 'select',
                      minWidth: 140,
                      dicData: [{
                        label: '已完成',
                        value: '已完成'
                      }, {
                        label: '未完成',
                        value: '未完成'
                      }]
                    },
                    // {
                    //   label: '总工时',
                    //   prop: 'ZGS',
                    //   minWidth: 140
                    // },
                    // {
                    //   label: '个人工时',
                    //   prop: 'gs',
                    //   minWidth: 140
                    // },
                    // {
                    //   label: '考核主管',
                    //   prop: 'KHZG',
                    //   type: 'select',
                    //   minWidth: 140,
                    //   dicData: []
                    // },
                    {
                      label: '备注',
                      prop: 'BZ',
                      minWidth: 300
                    }
                  ]
                }
              }
            ]
          }
        ]
      }
    }
  },
  mounted() {
    var date = new Date()
    var year = date.getFullYear()
    var month = date.getMonth() + 1
    var day = date.getDate()
    if (month < 10) {
      month = '0' + month
    }
    if (day < 10) {
      day = '0' + day
    }
    let txrq = year + '-' + month + '-' + day
    if (this.$route.query.hasOwnProperty('businessKey')) {
      this.$http.get('/fighter-workflow-saas/Zbgl/getZbnrById', {
        params: {
          id: this.$route.query.businessKey,
          _appKey: '%40PUBLIC'
        }
      }).then(response => {
        this.form = response.data
        this.form.processCode = this.$route.query.processCode
      })
    } else {
      this.startProcess()
      setTimeout(() => {
        this.loadData(txrq)
      }, 1000)
    }
    // this.getmyzgdic()
    // this.getmyzg()
    this.getUserInfo()
    this.$http.post('/fighter-workflow-saas/xrbManager/queryTaskType', null, {
      params: {
        pageNum: 1,
        pageSize: 999
      }
    }).then(response => {
      let list = response.data.records
      this.$set(this.option.group[1].column[1].children.column[this.findArray(this.option.group[1].column[1].children.column, 'RWLX', 'prop')], 'dicData', list)
    })
    // 三级任务属性
    // this.$http.post('/fighter-workflow-saas/rwxxzd/listTaskProperties').then(res => {
    //   this.sjrw = res.data[9].itemCode
    //   this.$set(this.option.group[1].column[1].children.column[this.findArray(this.option.group[1].column[1].children.column, 'SJRWSX', 'prop')], 'dicData', res.data)
    // })
  },
  methods: {
    startProcess() {
      this.$http.post('/fighter-workflow-saas/flow-ext/start-process-instance-by-key', {}, {
        params: {
          processDefinitionKey: 'ZBGL'
        }
      }).then(response => {
        console.log(response.data)
        this.ProcessKey = response.data
      })
    },
    getUserInfo() {
      this.$http.get('/fighter-lightportal-saas/personalCenter/getPersonalCenter').then(response => {
        this.$set(this.option.group[0].column[this.findArray(this.option.group[0].column, 'orgId', 'prop')], 'dicData', response.data.subject.orgList)
        if (response.data.subject.orgList.length !== 0) {
          this.form.orgId = response.data.subject.orgList[0].id
        }
        this.userInfo = response.data.subject
      })
    },
    // getmyzg() {
    //   this.$http.post('/fighter-workflow-saas/YbglController/getMyZg?_appKey=%40PUBLIC').then(res => {
    //     this.mykhzg = res.data[0].khrgh
    //   })
    // },
    // getmyzgdic() {
    //   this.$http.get('/fighter-workflow-saas/YbglController/getZg?searchKeyword=&_appKey=%40PUBLIC').then(res => {
    //     this.$set(this.option.group[1].column[1].children.column[this.findArray(this.option.group[1].column[1].children.column, 'KHZG', 'prop')], 'dicData', res.data)
    //   })
    // },
    loadData(txrq) {
      this.$http.get('/fighter-workflow-saas/Zbgl/getZbnr', {
        params: {
          TXRQ: txrq,
          _appKey: '%40PUBLIC'
        }
      }).then(response => {
        if (response.data.length === 0) {
          this.form.XM = this.userInfo.name
          this.form.LXDH = this.userInfo.loginName
          this.form.TXRQ = txrq
          this.form.processCode = this.$route.query.processCode || this.ProcessKey.formModelJsonList[0].group[0].column[12].value
          this.form.BZRW = {}
        } else {
          this.form.XM = this.userInfo.name
          this.form.LXDH = this.userInfo.loginName
          this.form.TXRQ = txrq
          this.form.processCode = this.$route.query.processCode || this.ProcessKey.formModelJsonList[0].group[0].column[12].value
          let str = response.data
          let _list = []
          for (let i = 0; i < str.length; i++) {
            // str[i].RWMC_TK = JSON.parse(str[i].RWMC_TK.replace(/\\/g, ''))
            str[i].ZRW_TK = JSON.parse(str[i].ZRW_TK.replace(/\\/g, ''))
            _list[i] = str[i]
          }
          this.form.BZRW = _list
        }
      })
    },
    handleCheckedSelect(datas, row) {
      row.ZRW_TK = []
      if (datas && datas.length > 0) {
        for (let i = 0; i < datas.length; i++) {
          row.ZRW_TK.push({ name: datas[i].ejrwmc, value: datas[i].ejrwid })
          row.ZRWID = datas[i].ejrwid
          row.ZRW = datas[i].ejrwmc
          row.RWMC = datas[i].yjrwmc
          row.RWID = datas[i].yjrwid
        }
      } else {
        row.ZRW_TK = []
        row.ZRWID = ''
        row.ZRW = ''
        row.RWMC = ''
        row.RWID = ''
      }
    },
    // 复制上周任务
    getcopszrw() {
      this.$http.post('/fighter-workflow-saas/rwxxzd/listLastWeekWeekly').then(res => {
        if (res.data.length === 0) {
          this.$message.warning('上周没有周报')
        } else {
          this.form.BZRW = []
          this.form.BZRW = res.data
        }
      })
    },
    // 获取本周日报
    getbzrw() {
      this.$http.post('/fighter-workflow-saas/rwxxzd/listThisWeekDailyReport').then(res => {
        if (res.data.length === 0) {
          this.$message.warning('本周没有日报')
        } else {
          this.form.BZRW = []
          this.form.BZRW = res.data
        }
      })
    },
    seavForm(form) {
      let setData = {
        id: form.id,
        orgId: form.orgId,
        GH: form.LXDH,
        LXDH: form.LXDH,
        TXRQ: form.TXRQ,
        XM: form.XM,
        BZRW: form.BZRW,
        processCode: form.processCode || this.ProcessKey.formModelJsonList[0].group[0].column[12].value,
        verifyFlag: '1',
        processInstanceId: this.$route.query.processInstanceId || this.ProcessKey.processInstanceId,
        taskId: this.$route.query.taskId || this.ProcessKey.taskId,
        taskDefinitionKey: this.$route.query.taskDefinitionKey || this.ProcessKey.taskDefinitionKey
      }
      this.$http.post('/fighter-workflow-saas/form-instance/save', setData, {
        params: {
          formId: this.$route.query.formId || this.ProcessKey.formKeyList[0],
          procDefId: this.$route.query.processInstanceId || this.ProcessKey.processDefinitionId
        }
      }, {}).then(response => {
        this.form.id = response.data.id
        this.$message.success(response.msg)
      }).catch(response => {
        this.$message.warning(response.msg)
      }).finally(() => {
        this.TABLE_LOADING = false // 表格转圈
      })
    },
    handleSubmit(form) {
      let setData = {
        id: this.$route.query.businessKey || '',
        orgId: form.orgId,
        GH: form.LXDH,
        LXDH: form.LXDH,
        TXRQ: form.TXRQ,
        XM: form.XM,
        BZRW: form.BZRW,
        processCode: form.processCode || this.ProcessKey.formModelJsonList[0].group[0].column[12].value,
        verifyFlag: '1',
        processInstanceId: this.$route.query.processInstanceId || this.ProcessKey.processInstanceId,
        taskId: this.$route.query.taskId || this.ProcessKey.taskId,
        taskDefinitionKey: this.$route.query.taskDefinitionKey || this.ProcessKey.taskDefinitionKey
      }
      if (form.BZRW.length === 0) {
        setTimeout(() => {
          this.$message.warning('请填写本周任务')
        }, 1000)
      } else {
        this.$http.post('/fighter-workflow-saas/form-instance/save', setData, {
          params: {
            isSubmitProcess: true,
            formId: '39c5ebc52bd445eaa5fd368f77c25d8e'
          }
        }, {}).then(response => {
          this.$message.success('提交成功')
          this.form.BZRW = []
          this.startProcess()
          this.$router.push(
            {
              path: `/applyForm?businessKey=${response.data.id}&processInstanceId=&taskId=&formId=39c5ebc52bd445eaa5fd368f77c25d8e&pageKey=VIEW&showNav=no&isIframe=true&isHiddenBtn=1`
            }
          )
        }).catch(response => {
          this.$message.warning(response.msg)
        }).finally(() => {
          this.TABLE_LOADING = false // 表格转圈
        })
      }
    }
  },
  watch: {
    txrq(newval, oldval) {
      if (oldval !== undefined && oldval !== '') {
        if (Date.parse(newval) !== Date.parse(oldval)) {
          this.loadData(newval)
        }
      }
    }
  }
}
</script>
<style lang="scss" scoped>
:deep(.avue-group__title) {
  font-size: 1.1rem;
  font-weight: 600;
}

:deep(.el-button--mini.is-circle) {
  padding: 6px;
}

:deep(.el-input__inner) {
  font-weight: bolder !important;
}

:deep(.el-textarea__inner) {
  font-weight: bolder !important;
}

:deep(.el-input.is-disabled .el-input__inner) {
  color: #606266;
}

:deep(.el-textarea.is-disabled .el-textarea__inner) {
  color: #606266;
}

:deep(.el-checkbox__input.is-disabled + span.el-checkbox__label) {
  color: #606266;
}

:deep(.el-radio__input.is-disabled + span.el-radio__label) {
  color: #606266;
}

:deep(.el-range-editor.is-disabled input) {
  color: #606266;
}

.layview {
  width: 100%;
  padding-left: 10px;
  padding-right: 10px;
  box-sizing: border-box;
  border-top-right-radius: 4px;
  border-top-left-radius: 4px;
  //   background-color: #f0f2f5;
}

// 顶部的标题
.header {
  width: 100%;
  box-sizing: border-box;
  //   margin-bottom: 10px;
}

.radius {
  border-radius: 7px;
}

.header-wrap {
  display: flex;
  align-items: center;
  height: 60px;
  border-top-right-radius: 7px;
  border-top-left-radius: 7px;
  background: #fff;
  box-sizing: border-box;
  padding: 0 30px;
  width: 100%;
  box-shadow: 2px 2px 2px 0px rgba(220, 220, 220, 0.5);
}

h1.top-title {
  margin: 0;
  font-size: 20px;
  font-weight: 400;
  line-height: 36px;
  color: #409eff;
  margin-right: auto;
}

.viewmain {
  :deep(.avue-group .el-collapse-item__wrap) {
    border: 0;
    padding: 0 20px;
  }

  :deep(.avue-group .el-collapse) {
    border: 0;
    margin-bottom: 10px;
    border-radius: 7px;
    overflow: hidden;
  }

  :deep(.avue-group__header) {
    padding-left: 30px;
  }
  :deep(.el-tooltip .el-input__inner) {
    overflow: hidden; //超出的文本隐藏
    text-overflow: ellipsis; //溢出用省略号显示
    white-space: nowrap; // 默认不换行；
  }
}
</style>
